import { z } from 'zod'

import {
  EMAIL_MAX_LENGTH,
  isEmailLocalPartTooLong,
} from '@/utils/validate-email'

export const resetPasswordFormValidationSchema = z
  .object({
    password: z
      .string()
      .min(8, 'A senha deve conter no mínimo 8 caracteres')
      .max(50, 'A senha deve conter no máximo 50 caracteres')
      .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
      .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
      .regex(/\d/, 'A senha deve conter pelo menos um número')
      .regex(
        /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/,
        'A senha deve conter pelo menos um caractere especial',
      )
      .regex(/^\S*$/, 'A senha não deve conter espaços'),
    confirmPassword: z
      .string()
      .min(1, 'Esse campo é obrigatório')
      .max(50, 'A senha deve conter no máximo 50 caracteres'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas não conferem',
    path: ['confirmPassword'],
  })

export type ResetPasswordFormValues = z.infer<
  typeof resetPasswordFormValidationSchema
>

export const resetPasswordEmailFormValidationSchema = z.object({
  email: z
    .string()
    .email('Insira um endereço de email válido.')
    .min(1, 'Insira seu endereço de email.')
    .max(
      EMAIL_MAX_LENGTH,
      `O endereço de email deve ter no máximo ${EMAIL_MAX_LENGTH} caracteres.`,
    )
    .superRefine((email, ctx) => {
      const { isTooLong, maxLength } = isEmailLocalPartTooLong({
        email,
      })

      if (isTooLong) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `O email antes do @ deve ter no máximo ${maxLength} caracteres.`,
        })
      }
    }),
})

export type ResetPasswordEmailFormValues = z.infer<
  typeof resetPasswordEmailFormValidationSchema
>
